import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Button, Flex, message, Modal, Spin } from "antd";
import "./style.scss";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import AddQuestionSidebar from "./sidebar";
import SettingQuestionCourse from "../../../../content-construction/add-survy/add-survy-core/setting-question-course/setting-question-course";
import CustomCard from "../../../../../components/custom-card/CustomCard";
import { useAddLesson } from "../../../../../stores/stores";
import { useNavigate, useParams } from "react-router-dom";
import { convertQuillToString } from "../../../../../utils/convertQuillToString";
import { mapAnsFEtoBE } from "../../../../../utils/arrays";
import { stripHtml } from "../../../../../utils/app";
import { isEmpty, toNumber } from "lodash";
import { ModeQuestion, QuestionTypeEnum } from "../../../../../constants";
import { VariableDefinitionsProps } from "../../../../../types/course";
import { extractTextFromHtml } from "../../../../../utils/format";
import {
  createQuizConnectIntoBank,
  createQuizDraftConnectIntoBank,
  createQuizDraftIntoBank,
  createQuizIntoBank,
  deleteQuizFromBank,
  searchQuizInQuestionBank,
  updateQuizConnectInBank,
  updateQuizDraftConnectInBank,
  updateQuizDraftInBank,
  updateQuizInBank,
} from "../../../../../service/question-bank";
import { QuizInfoInBank } from "../../../../../types/question-bank";
import Content from "./question-content/Content";
import useKeyword from "../../../../../hooks/useKeyword";
import { getQuizById } from "../../../../../service/course-construct";
import {
  ConnectQuestionData,
  QuestionData,
} from "../../../../../types/course-construction";
import { useDirty } from "../../../../../contexts/DirtyProvider";

function AddQuestionsIntoBank() {
  const { t } = useTranslation();
  const params = useParams();
  const bankId = toNumber(params?.id);
  const name = useKeyword("name");
  const navigate = useNavigate();
  const currentQuizEditInBank = useKeyword("quizId");
  const currentQuizVersion = useKeyword("version");

  const [currentQuizId, setCurrentQuizId] = useState<number>(0);
  const [loadingQuestion, setLoadingQuestion] = useState<boolean>(false);
  const [connectQuestionData, setConnectQuestionData] =
    useState<ConnectQuestionData>({} as ConnectQuestionData);
  const [questionData, setQuestionData] = useState<QuestionData>(
    {} as QuestionData
  );
  const setQuestionSettingsBe = useAddLesson(
    (state) => state.setQuestionSettingsBe
  );

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [refreshPage, setRefreshPage] = useState<boolean>(false);
  const [quizzes, setQuizzes] = useState<QuizInfoInBank[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingDetail, setLoadingDetail] = useState<boolean>(false);
  const [isNewQuiz, setIsNewQuiz] = useState<boolean>(false);
  const {
    question,
    modeQuestion,
    settingQuestion,
    currentQuestionInfo,
    settingPopupQuestion,
    currentQuizVersionId,
    setQuestion,
    setQuizInfo,
    setModeQuestion,
    setTypeQuestionChoose,
    setCurrentQuestionInfo,
    setCurrentQuizVersionId,
    setCurrentIdQuestionAdd,
  } = useAddLesson();

  useEffect(() => {
    if (!currentQuizEditInBank) {
      setQuestion({});
      setModeQuestion("");
      setTypeQuestionChoose("");
      setCurrentIdQuestionAdd(0);
      setCurrentQuestionInfo({});
    }
  }, [currentQuizEditInBank]);

  useEffect(() => {
    const getQuizzes = async () => {
      setLoading(true);
      const res = await searchQuizInQuestionBank({
        bankId: bankId,
      });
      setQuizzes(res.data?.data?.content);
      setLoading(false);

      if (isNewQuiz) {
        setQuestion(res.data?.data?.content?.[0]);
        setModeQuestion(ModeQuestion.UPDATE);
      }
    };
    getQuizzes();
  }, [bankId, refreshPage]);

  const createQuiz = async (dataReq: any, submitType: "version" | "draft") => {
    try {
      setLoadingSubmit(true);
      let apiResponse: any;
      if (question.type === QuestionTypeEnum.CONNECT) {
        if (submitType === "version")
          apiResponse = await createQuizConnectIntoBank(dataReq);
        else apiResponse = await createQuizDraftConnectIntoBank(dataReq);
      } else {
        if (submitType === "version")
          apiResponse = await createQuizIntoBank(dataReq);
        else apiResponse = await createQuizDraftIntoBank(dataReq);
      }
      setRefreshPage(!refreshPage);
      const dataRespone = apiResponse.data;
      setCurrentIdQuestionAdd(dataRespone.body.id);
      message.success(dataRespone.body.message);
      setIsNewQuiz(true);
      setDirty(false);
    } catch (err: any) {
      message.warning(err?.message || t("Tạo mới thất bại", "Tạo mới thất bại"));
      console.error(err);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const updateQuiz = async (dataReq: any, submitType: "version" | "draft") => {
    try {
      setLoadingSubmit(true);
      if (question.type === QuestionTypeEnum.CONNECT) {
        if (submitType === "version") await updateQuizConnectInBank(dataReq);
        else await updateQuizDraftConnectInBank(dataReq);
      } else {
        if (submitType === "version") {
          await updateQuizInBank(dataReq);
        } else {
          if (question.draftId) {
            const newDataReq = {
              ...dataReq,
              id: question.draftId,
            };
            await updateQuizDraftInBank(newDataReq);
          } else {
            await updateQuizDraftInBank(dataReq);
          }
        }
      }
      setIsNewQuiz(false);
      setRefreshPage(!refreshPage);
      message.success(t("Cập nhật câu hỏi thành công", "Cập nhật câu hỏi thành công"));
      setDirty(false);
    } catch (err: any) {
      message.warning(err?.message || t("Cập nhật thất bại", "Cập nhật thất bại"));
      console.error(err);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleDeleteFromBank = async () => {
    Modal.confirm({
      title: t("Xoá câu hỏi", "Xoá câu hỏi"),
      content: t("Bạn có muốn xoá câu hỏi này khỏi ngân hàng?", "Bạn có muốn xoá câu hỏi này khỏi ngân hàng?"),
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ", "Huỷ"),
      onOk: async () => {
        if (!question.id) {
          message.warning(t("Không tìm thấy câu hỏi", "Không tìm thấy câu hỏi"));
          return;
        }

        try {
          await deleteQuizFromBank(question.id);
          message.success(t("Xoá câu hỏi thành công", "Xoá câu hỏi thành công"));
          setRefreshPage(!refreshPage);
          setQuestion({});
          setModeQuestion("");
        } catch (err: any) {
          message.warning(err?.message || t("Thao tác thất bại", "Thao tác thất bại"));
          console.error(err);
        } finally {
          setLoadingSubmit(false);
        }
      },
      onCancel() {},
    });
  };

  const handleSaveQuestion = (submitType: "version" | "draft") => {
    let payload: any;

    payload = {
      id: question.id,
      orderNumber: 1,
      questionBankId: bankId,
      type: question.type,
      question: currentQuestionInfo.questionName,
      questionValue: convertQuillToString(currentQuestionInfo.questionName),
      answers: mapAnsFEtoBE(currentQuestionInfo, question.type as number),
      reminderText: currentQuestionInfo.reminderText,
      settingGeneral: {
        showForViewer: settingQuestion.isVisibleToViewers,
        requiredAnswer: settingQuestion.isRequiredAnswer,
        haveCorrectAnswer: settingQuestion.canEnterAnswer,
        isAutoMark: settingQuestion.canEnterAnswer,
        shuffleQuestion: settingQuestion.isRandomOrder,
        fileQuantity: settingQuestion.fileQuantity,
        fileCapacity: settingQuestion.fileCapacity,
        numberingType: settingQuestion.markNumber,
        timeToPlay: settingPopupQuestion.defaultQuestion
          ? settingQuestion.timeToPlay
          : 0,
        displayScoreCriteria: settingQuestion.displayScoreCriteria,
      },
      settingPoint: {
        isPerQuiz: settingQuestion.isSetScore4EachAns,
        correct: settingQuestion.scoreOfCorrect,
        incorrect: settingQuestion.scoreOfInCorrect,
      },
      settingHint: {
        isDisplayInstruction: settingQuestion.isShowGuide,
        content: settingQuestion.hintContent,
        uri: settingQuestion.uri,
        schema: settingQuestion.schema,
      },
      settingResponse: {
        isDisplayPerResponse: settingQuestion.isFeedback4EachAns,
        correct: settingQuestion.correctAns,
        incorrect: settingQuestion.incorrectAns,
        notYet: settingQuestion.notAnswer,
      },
    };

    const strippedQuestionName = stripHtml(
      extractTextFromHtml(currentQuestionInfo.questionName)
    ).trim();

    const checkArr = payload.answers.some((i: any) => isEmpty(i.filePath));

    if (payload.type === QuestionTypeEnum.NUMERICAL) {
      const tolerance =
        currentQuestionInfo?.tolerance ||
        currentQuestionInfo[0]?.tolerance ||
        0;
      payload.answers = [
        {
          ...mapAnsFEtoBE(currentQuestionInfo, question.type as number)[0],
          tolerance: tolerance,
        },
      ];
    }

    if (
      payload.type === QuestionTypeEnum.CALCULATED ||
      payload.type === QuestionTypeEnum.CALCULATED_SIMPLE ||
      payload.type === QuestionTypeEnum.CALCULATED_MULTI
    ) {
      const variableDefinitions =
        currentQuestionInfo?.variableDefinitions ||
        currentQuestionInfo[0]?.variableDefinitions;
      const tolerance =
        currentQuestionInfo?.tolerance ||
        currentQuestionInfo[0]?.tolerance ||
        0;
      const hasEmptyPredefinedValues = variableDefinitions?.some(
        (v: VariableDefinitionsProps) => isEmpty(v.predefinedValues)
      );

      if (hasEmptyPredefinedValues) {
        message.error(t("Vui thiết lập giá trị ngẫu nhiên cho câu hỏi", "Vui thiết lập giá trị ngẫu nhiên cho câu hỏi"));
        return;
      }

      payload.answers =
        payload.type === QuestionTypeEnum.CALCULATED_MULTI
          ? mapAnsFEtoBE(currentQuestionInfo, question.type as number)
              .map((quest: any) => {
                return {
                  ...quest,
                  variableDefinitions: variableDefinitions,
                  tolerance: tolerance,
                  content: extractTextFromHtml(quest?.content),
                };
              })
              .filter(
                (quest: any) =>
                  quest?.isTrue !== null && quest?.isTrue !== undefined
              )
          : [
              {
                ...mapAnsFEtoBE(
                  currentQuestionInfo,
                  question.type as number
                )[0],
                variableDefinitions: variableDefinitions,
                tolerance: tolerance,
                content: extractTextFromHtml(currentQuestionInfo[0]?.value),
              },
            ];
    }
    if (
      (QuestionTypeEnum.CHOOSE_VIDEO === payload.type ||
        QuestionTypeEnum.CHOOSE_MULTI_VIDEO === payload.type ||
        QuestionTypeEnum.CHOOSE_IMAGE === payload.type ||
        QuestionTypeEnum.CHOOSE_MULTI_IMAGE === payload.type) &&
      checkArr &&
      payload.answers.length !== 0
    ) {
      message.error(t("Không được bỏ trống các giá trị file và nội dung", "Không được bỏ trống các giá trị file và nội dung"));
    } else if (strippedQuestionName.length === 0) {
      message.error(t("Không được bỏ trống nội dung câu hỏi", "Không được bỏ trống nội dung câu hỏi"));
    } else {
      if (modeQuestion === ModeQuestion.CREATE) {
        createQuiz(payload, submitType);
      }
      if (modeQuestion === ModeQuestion.UPDATE) {
        updateQuiz(payload, submitType);
      }
    }
  };

  // Get quiz detail
  const getDetailQuestion = async (questId?: number) => {
    try {
      if (currentQuizId && modeQuestion === ModeQuestion.UPDATE) {
        setLoadingQuestion(true);
        setQuestionData({} as QuestionData);
        const quizDetail = await getQuizById(questId || currentQuizId);
        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        setQuizInfo(quizDetail.data.body);
        setQuestionSettingsBe(quizDetail.data || {});
      }
    } catch (err: any) {
    } finally {
      setLoadingQuestion(false);
    }
  };

  useEffect(() => {
    if (question.id) {
      // Khởi tạo
      setCurrentQuizId(question.id);
    }
  }, [question.id]);

  useEffect(() => {
    // Check version khác của quizz
    if (currentQuizVersionId) {
      const getQuizByVersion = async () => {
        setLoadingQuestion(true);

        const quizDetail = await getQuizById(currentQuizVersionId);

        if (question.type === QuestionTypeEnum.CONNECT) {
          setConnectQuestionData(quizDetail.data.body);
        } else {
          setQuestionData(quizDetail.data.body);
        }
        if (quizDetail.data.body.id !== question.id) {
          setQuestion({
            ...quizDetail.data.body,
            id: question.id,
          });
        }
        setLoadingQuestion(false);
      };
      getQuizByVersion();
    }
    return () => setCurrentQuizVersionId(null);
  }, [currentQuizVersionId]);

  useEffect(() => {
    if (modeQuestion === "") {
      setQuestion({});
      setQuestionData({} as QuestionData);
    }
    if (modeQuestion === ModeQuestion.CREATE) {
      setQuestionData({ question: question.question } as QuestionData);
    }
  }, [modeQuestion]);

  useEffect(() => {
    getDetailQuestion();
  }, [currentQuizId, modeQuestion]);

  const { isDirty, setDirty } = useDirty();

  return (
    <div className="add-quest-page">
      <div className="page-add-quest-header">
        <Flex justify="space-between" align="center">
          <Flex gap={12}>
            <ArrowLeftOutlined
              onClick={() => {
                navigate(-1);
              }}
              style={{ fontSize: 17 }}
            />
            <div className="page-title">{t("Ngân hàng câu hỏi/", "Ngân hàng câu hỏi/")}{name}</div>
          </Flex>
          <div className="add-q-header-buttons">
            <Flex gap={16}>
              {modeQuestion === ModeQuestion.UPDATE && (
                <Button
                  icon={<DeleteOutlined />}
                  onClick={handleDeleteFromBank}
                >
                  {t("Xoá", "Xoá")}
                </Button>
              )}
              <Button
                icon={<SaveOutlined />}
                className="btn-primary"
                onClick={() => handleSaveQuestion("draft")}
                loading={loadingSubmit}
                disabled={isEmpty(question) || !isDirty}
              >
                {t("Lưu nháp", "Lưu nháp")}
              </Button>
              <Button
                icon={<SaveOutlined />}
                className="btn-primary"
                onClick={() => handleSaveQuestion("version")}
                loading={loadingSubmit}
                disabled={isEmpty(question) || !isDirty}
              >
                {t("Lưu phiên bản", "Lưu phiên bản")}
              </Button>
            </Flex>
          </div>
        </Flex>
      </div>
      <Spin spinning={loading}>
        <Flex justify="space-between">
          {currentQuizVersion ? null : (
            <AddQuestionSidebar
              loadingDetail={loadingDetail}
              quizzes={quizzes}
              onRefresh={() => setRefreshPage(!refreshPage)}
              setLoading={setLoading}
            />
          )}

          <CustomCard className="card-info--wrapper flex-1 question-content-card">
            <div
              className="list-wrapper"
              style={{
                paddingTop:
                  question && Object.keys(question).length !== 0 ? 0 : "24%",
              }}
            >
              {question && Object.keys(question).length !== 0 ? (
                <Content setLoadingDetail={setLoadingDetail} />
              ) : (
                <span style={{ textAlign: "center" }}>
                  <p>
                    <img
                      className="image-empty-data"
                      src="/images/empty-img-gray.png"
                      alt="empty-img"
                    />
                  </p>
                  <p className="nodata-text" style={{ color: "#999" }}>
                    {t("Xin vui lòng chọn câu hỏi", "Xin vui lòng chọn câu hỏi")}
                  </p>
                </span>
              )}
            </div>
          </CustomCard>

          <div className={"add-quest-setting"}>
            <SettingQuestionCourse hiddenToggle showQuizInfo={true} />
          </div>
        </Flex>
      </Spin>
    </div>
  );
}

export default AddQuestionsIntoBank;
